import * as actions from './actions'

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/descriptionEspace/index.js